import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from 'components/Grid/GridItem';
import { Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  avatar: {
    width: '16px',
    height: '24px',
  },
  legend: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '8px',
  },
  contLegend: {
    display: 'flex',
    fontWeight: 'bold',
    '& img': {
      height: '100%',
    },
    '& span': {
      marginLeft: '5px',
      color: 'black',
    },
  },
}));

const Legend = (props) => {
  const { legends } = props;
  const classes = useStyles();
  return (
    <GridItem xs={12} sm={12} md={12}>
      <div className={classes.legend}>
        {legends.map((legend, index) => {
          return (
            <div className={classes.contLegend} key={index}>
              <Avatar src={legend.imageSrc} variant="square" className={classes.avatar} />
              <span>{legend.title}</span>
            </div>
          );
        })}
      </div>
    </GridItem>
  );
};

Legend.propTypes = {
  legends: PropTypes.arrayOf(
    PropTypes.shape({
      imageSrc: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
};

export default Legend;
